<template>
	<!-- <van-config-provider :theme-vars="themeVars"> -->
	<div class="content">
		<!-- 顶部进度条计时器 -->
		<div class="header">
			<div class="num">
				<span class="currentIndex-num">{{ currentIndex + 1 }}</span>/
				<span>{{ examPaper.length }}</span>
			</div>
			<div class="progress">
				<van-progress
					:percentage="percentage"
					stroke-width="10px"
					color="#FF5D7D"
					:show-pivot="false"
				/>
			</div>
			<div class="time">
				<van-icon name="clock-o" />
				<van-count-down
					:time="time"
					:auto-start="false"
					ref="countDown"
				/>
			</div>
			<div
				v-if="goodsInfo.has_goods_notice === 1"
				class="question"
				@click="questionVisible = true"
			>
				<i class="fa fa-question"></i>
			</div>
		</div>

		<!-- 题目区域 -->
		<div
			class="exam-list"
			:class="{ 'animate-next': animate }"
		>
			<div class="title">{{ currentIndex + 1 }}、{{ current.subject }}</div>

			<div
				v-if="current.subject_image"
				class="title-img"
			>
				<img :src="current.subject_image" />
			</div>

			<div
				class="item-list"
				:class="{ 'wrap-list': isImgSubject }"
			>
				<div
					class="item"
					:class="{ active: isActive(index) }"
					v-for="(item, index) in current.option"
					:key="index"
					@click="handleOption(index)"
				>
					<span
						class="option"
						v-if="!isImgSubject"
					>{{
							optionNames[index]
					}}</span>
					<span>{{ item.name }}</span>
					<img
						:src="item.img"
						v-if="isImgSubject"
					/>
				</div>
			</div>
		</div>

		<!-- 底部上一步下一步 -->
		<footer class="footer">
			<div
				class="last-next"
				v-show="!isLast"
			>
				<div
					v-if="currentIndex !== 0"
					class="button"
					@click="handleLast"
				>
					上一题
				</div>
				<div
					v-if="showNext"
					class="button"
					@click="handleNext"
				>下一题</div>
			</div>
			<div
				class="last-next"
				v-show="isLast"
			>
				<div
					class="button"
					@click="handleLast"
				>上一题</div>

				<div
					v-if="!disabled"
					class="button animation-button"
					@click="handleLookReport"
				>
					查看报告
				</div>
			</div>
			<!-- <div
          class="to-view"
          :class="{'disabled':disabled}"
          v-show="isLast"
          @click="handleLookReport"
        >
          查看报告
      </div>-->
		</footer>
	</div>

	<!-- 用户需知 -->
	<InstructionsDialog
		v-model:show="questionVisible"
		:data="goodsInfo"
	/>
	<ChooseBirthday
		:paperSet="paperSet"
		v-model:show="dateShow"
		@confirm="handleBirthdayConfirm"
	/>
	<!-- </van-config-provider> -->
</template>

<script>
import {
	reactive,
	toRefs,
	computed,
	onMounted,
	onBeforeUnmount,
	ref,
	nextTick,
	unref,
} from "vue";
import ChooseBirthday from "@/components/ChooseBirthday";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import InstructionsDialog from "./components/InstructionsDialog";
import { Notify, Toast } from "vant";
import {
	getExamPaper,
	answerSave,
	examPaperSave,
	getDetailAnswer,
} from "@/api/goods";
import { checkGoodsOrder } from "@/api/pay";
import { useEventListener } from "@/hooks/useEventListener";
import { setBirthday } from "@/api/common";
import { Dialog } from "vant";
import { loadingToast } from "@/plugins/vant";
import { useStore } from "@/store";
import qs from "qs";
import { optionNames } from "../letter";
import { useWx } from "@/hooks/useWx";
export default {
	name: "exam",
	components: {
		InstructionsDialog,
		ChooseBirthday,
	},

	setup() {
		const store = useStore();
		const router = useRouter();
		const route = useRoute();
		const themeVars = {
			vanActionBarButtonDangerColor: "#ff5d7d",
		};
		// 试卷订单ID
		const { paper_order_sn, guid, puid, coupon_code } = route.query;
		window.localStorage.setItem("paper_order_sn", paper_order_sn);

		// 计时器ref
		const countDown = ref(null);
		const state = reactive({
			optionNames,
			// 评测须知显示隐藏
			questionVisible: false,
			// 当前题目索引
			currentIndex: 0,
			// 已回答的题目
			answerList: [],

			// 试卷列表
			examPaper: [],

			time: 0,
			// 动画显示
			animate: true,

			// 商品信息
			goodsInfo: {},

			// 生日选择
			dateShow: false,

			// 试卷信息
			paper_info: {},

			notify: null,
			// 年龄选择
			paperSet: {},
			isStop: true,
			backStatu: false,
			isReplace: false,
			paper_tips: {}, //tips
			showNext: false,
		});
		// onBeforeRouteLeave((to, from, next) => {
		// if(this.backStatu){
		//   next(true);
		// }else{
		// 	next(false);
		// }
		// this.tipshow = true;
		// return false;
		// });
		// 当前题目
		const current = computed(() => state.examPaper[state.currentIndex] || {});
		// 当前题目答案
		const currentOptionAnswer = computed(() =>
			state.answerList.find((v) => v.id === current.value.id)
		);
		// 最后一题是否回答完毕
		const disabled = computed(
			() => state.answerList.length < state.examPaper.length
		);
		// 是否已经是最后一题
		const isLast = computed(
			() => state.currentIndex === state.examPaper.length - 1
		);

		// 进度条当前进度
		const percentage = computed(() => {
			if (!state.examPaper.length) return 0;
			const value = ((state.currentIndex + 1) / state.examPaper.length) * 100;
			if (value >= 100) {
				return 100;
			}
			return value;
		});

		// 初始化试卷
		async function init() {
			const {
				data: {
					paper_order_detail,
					goods_info,
					paper_info,
					paperSet,
					paper_tips,
				},
			} = await getExamPaper({ paper_order_sn });
			document.querySelector('meta[name="description"]')?.setAttribute("content", paper_info.subtitle);
			state.examPaper = paper_order_detail;
			state.goodsInfo = goods_info;
			state.paper_info = paper_info;
			state.time = paper_info.countdown * 60 * 1000;
			state.paperSet = paperSet;
			state.paper_tips = Object.fromEntries(
				paper_tips.map((e) => [e.paper_detail_no, e.tips])
			);

			document.title = paper_info.subtitle;
			nextTick(() => countDown.value?.start());
		}
		// 根据订单号 获取已经答过的答案
		async function getAnswer() {
			const { data } = await getDetailAnswer({ paper_order_sn });
			if (data.length > 0) {
				state.currentIndex = data.length - 1;
				state.answerList = data;
				if (route.path !== "/exam") return;
				state.notify = Notify({
					message: `已经加载${state.answerList.length}道答题记录，点此重新做题`,
					background: "#2196F3",
					duration: 0,
					onClick: () => {
						state.answerList = [];
						state.currentIndex = 0;
						state.notify?.close();
					},
				});
			} else {
				if (state.paperSet.needSet == 1 && state.paperSet.setType == 1) {
					// state.dateShow = true;
					goChooseYear();
				}
			}
		}

		// 题目点击
		async function handleOption(index) {
			if (!state.animate) return;

			state.notify?.close();

			// 判断已回答列表中是否有该题目 没有则将答案及试卷id push进去
			if (currentOptionAnswer.value) {
				// 有该条答案 则修改该答案
				const val = state.answerList.find((v) => v.id === current.value.id);
				val.answer = index;
			} else {
				state.answerList.push({
					id: current.value.id,
					answer: index,
				});
			}

			// 判断最后一题是否回答完毕
			if (isLast.value) {
				Notify({
					message: "答题完毕，请点击下方“查看报告”按钮",
					background: "#07c160",
				});
			} else {
				handleNext();
			}
			if ((state.currentIndex + 1) % 5 === 0 || isLast.value) {
				// 提交每一题的答案
				await answerSave({
					paper_order_sn,
					answerData: state.answerList,
				});
			}

		}
		// 题目是否已选择
		function isActive(index) {
			return currentOptionAnswer.value?.answer === index;
		}

		// 下一题按钮
		function handleNext() {
			if (!state.animate) return;
			if (!currentOptionAnswer.value) {
				return Toast("请选择您的答案");
			}
			state.animate = false;

			window.setTimeout(() => {
				state.animate = true;
				state.currentIndex += 1;
				state.paper_tips[state.currentIndex] &&
					Dialog.alert({
						message: state.paper_tips[state.currentIndex],
						theme: "round-button",
					}).then(() => { });
				if (!currentOptionAnswer.value) {
					state.showNext = false;
				}
			}, 300);
			state.notify?.close();
		}
		// 上一题按钮
		function handleLast() {
			if (state.currentIndex === 0) {
				return Toast("没有上一题了");
			}
			state.showNext = true;
			state.currentIndex += -1;
			state.notify?.close();
		}

		// 生日选择确定按钮
		async function handleBirthdayConfirm(age) {
			await setBirthday({
				age: Number(age),
				paper_order_sn,
			});

			// 后置年龄选择器
			if (state.paperSet.setType == 2) {
				handleReport();
			} else {
				// 前置年龄选择器
				state.dateShow = false;
			}
		}

		// 查看报告按钮
		async function handleLookReport() {
			if (disabled.value) return Toast("请选择最后一题的答案");
			window.loading = loadingToast();

			if (state.paperSet.needSet == 1 && state.paperSet.setType == 2) {
				// state.dateShow = true;
				goChooseYear();
			} else {
				handleReport();
			}
		}

		// 查看报告
		async function handleReport() {
			try {
				setTimeout(() => {
					window.loading?.clear?.();
				}, 5000);
				await examPaperSave({
					paper_order_sn,
					answerData: state.answerList,
				});

				const { data } = await checkGoodsOrder({ paper_order_sn });

				state.isReplace = true;
				// data为1 已支付状态

				if (data === 1) {

					router.replace({
						path: "/report",
						query: {
							paper_order_sn,
							guid,
							puid,
						},
					});
				} else {
					// 跳转支付引导页
					router.replace({
						path: "/pay",
						query: {
							paper_order_sn,
							guid,
							puid,
							coupon_code
						},
					});
				}



			} catch (error) { }
		}
		async function holdback() { }
		const { on, off } = useEventListener();
		onBeforeUnmount(() => {
			state.notify?.close();
			off(window, "popstate", holdback);
		});

		// 检查订单状态
		function checkStatus() {
			return new Promise(async (resolve, reject) => {
				const { paper_order_sn, guid, puid, type } = route.query;
				// 重测订单 则不检测 并清除重测参数
				if (type === "reset") {
					const query = {
						...route.query,
						type: undefined,
					};
					const search = qs.stringify(query);
					window.history.replaceState(
						null,
						null,
						`${window.location.origin + route.path}?${search}`
					);
					resolve();
					return;
				}
				const { data } = await checkGoodsOrder({ paper_order_sn });
				if (data === 1) {
					state.isReplace = true;
					router.replace({
						path: "/goods",
						query: {
							guid,
							puid,
						},
					});
					reject();
				} else {
					resolve();
				}
			});
		}

		onMounted(async () => {
			useWx({ type: 2, guid, puid });
			await checkStatus();

			try {
				await init();
				getAnswer();
				// 监听浏览器后退事件
				// window.history.pushState(null, null, document.URL);
				// on(window, "popstate", holdback);
			} catch (error) {
				state.isReplace = true;
				if (guid || puid) {
					router.replace({
						path: "/goods",
						query: {
							guid,
							puid,
						},
					});
				} else {
					router.replace("/");
				}
			}
		});
		onBeforeRouteLeave((to, from, next) => {
			if (state.isReplace) {
				next();
			} else {
				// 退出的时候返回上一页
				state.isStop = false;
				state.backStatu = true;
				next();
				// return false;
				// setTimeout(() => {
				//   Dialog.confirm({
				//     title: "提示",
				//     message: "测试未完成，确定放弃？",
				//     confirmButtonText: "继续答题",
				//     cancelButtonText: "退出",
				//     closeOnPopstate: false,
				//   })
				//     .then(async () => {

				//       next(false);
				//     })
				//     .catch(async () => {

				//       // 退出的时候返回上一页
				//       state.isStop = false;
				//       state.backStatu = true;
				//       next();
				//     });
				// }, 200);
			}
		});
		const goChooseYear = async () => {
			await examPaperSave({
				paper_order_sn,
				answerData: state.answerList,
			});
			localStorage.setItem("answerList", JSON.stringify(state.answerList));
			localStorage.setItem("statePaperSet", JSON.stringify(state.paperSet));

			router.push({
				path: "/chooseYear",
				query: route.query,
			});
		};
		const isImgSubject = computed(() => {
			const isImg = unref(current).option?.find((item) => item.img);
			return !!isImg;
		});

		return {
			handleNext,
			handleLast,
			handleOption,
			isActive,
			handleLookReport,
			isLast,
			disabled,
			percentage,
			current,
			countDown,
			handleBirthdayConfirm,
			...toRefs(state),
			isImgSubject,
		};
	},
};
</script>

<style lang="less" scoped>
::v-global(.van-action-bar-button--danger) {
	background: #ff5d7d !important;
}

.animate-next {
	animation-duration: 0.3s;
	animation-duration: 0.3s;
	animation-fill-mode: both;
	animation-name: next;
}

@keyframes next {
	0% {
		transform: translateX(375px);
		opacity: 0.7;
	}

	80% {
		transform: translateX(0);
		opacity: 0.7;
	}

	to {
		opacity: 1;
	}
}

@keyframes scale {
	0% {
		transform: scale(1);
	}

	25% {
		transform: scale(1.1);
	}

	50% {
		transform: scale(1);
	}

	75% {
		transform: scale(1.1);
	}
}

.content {
	background-color: #f5f5f5;
	min-height: 100vh;
	padding-bottom: 50px;
	overflow-x: hidden;

	.header {
		height: 50px;
		padding: 0 @padding-base;
		background-color: #fff;
		box-shadow: 0 1px 6px rgba(#000, 0.1);
		.space-between();
		.align-center();
		color: @gray-color;

		.van-icon {
			font-size: @font-size-base;
		}

		.van-count-down {
			font-size: @font-size-sm;
			color: @gray-color;
			padding-left: 5px;
		}

		.num {
			font-size: @font-size-sm;

			.currentIndex-num {
				font-size: @font-size-lg;
				color: #000;
				font-weight: bold;
			}
		}

		.time {
			.align-center();
		}

		.progress {
			width: 200px;
		}

		.question {
			font-size: @font-size-base;
			width: 20px;
			height: 20px;
			border: 1px solid #f1f3f4;
			border-radius: 3px;
			.align-center();
			justify-content: center;
		}
	}

	.exam-list {
		padding: @padding-base @padding-base 5px @padding-base;

		.title {
			font-weight: bold;
			font-size: 18px;
		}

		.wrap-list {
			display: flex;
			flex-wrap: wrap;

			.item {
				width: 49%;
				padding: 5px @padding-base !important;

				img {
					height: 50px;
					margin: 0 auto;
				}

				&:nth-child(2n + 1) {
					margin-right: 2%;
				}
			}
		}

		.item-list {
			margin-top: @padding-sm;

			.item {
				background-color: #fff;
				border-radius: 5px;
				padding: 12px @padding-base;
				line-height: 25px;
				font-size: @font-size-base;
				display: flex;
				margin-bottom: 2%;
				cursor: pointer;

				.option {
					.align-center();
					padding-right: @padding-sm;
				}

				&.active {
					background-color: @theme-color;
					color: #fff;
				}
			}
		}
	}

	.footer {
		.align-center();
		justify-content: center;

		.last-next {
			width: 100%;
			margin-bottom: 20px;
			padding: 0 15px;
			.space-between();
			.align-center();
		}

		.fixed-bottom();
		background: transparent;

		.footer-button() {
			height: 38px;
			line-height: 38px;
			text-align: center;
			border-radius: 38px;
			color: #fff;
			font-size: @font-size-base;
		}

		.button {
			width: 150px;
			background-color: @theme-color;
			.footer-button();

			&.animation-button {
				animation: scale 3s infinite;
				background: #07c160;
			}
		}

		.to-view {
			width: 95%;
			height: 38px;
			margin-bottom: 20px;
			.footer-button();
			background-color: @theme-color;
		}

		.disabled {
			background-color: #cccccc;
		}
	}
}

.title-img {
	width: 85%;
	margin: 0 auto;
	padding-top: @padding-sm;

	img {
		width: 100%;
	}
}

:root {
	--van-action-bar-button-danger-color: #ff5d7d;
}
</style>
